// Centralised admin URL slug. Changing this single value rotates the
// admin entry point everywhere (App.js routes + redirects).
// The /admin path is intentionally a 404 so brute-force scrapers see nothing.
export const ADMIN_ROUTE = "/atelier-control-x9k2";
export const ADMIN_DASHBOARD_ROUTE = `${ADMIN_ROUTE}/dashboard`;
